
<div id="container">
    <h2 id="text">Course Fee Master</h2>
    <div id="secondContainer">
     <table class="table table-striped table-hover">
         <tbody>
             <tr>
                 <td class="maintext">Course Fee</td>
                 <td>{{ totalCourseFee }}</td>
               </tr>
               <tr>
                 <td>Max Concession</td>
                 <td>{{ maxconcession }}</td>
               </tr>
               <tr>
                 <td>Org Concession</td>
                 <td>{{ orgconcession }}</td>
               </tr>
               <tr>
                 <td>Course Strength</td>
                 <td>{{ coursestrength }}</td>
               </tr>
               <tr>
                 <td>Registration Fee</td>
                 <td>{{ registrationfee }}</td>
               </tr>
               <tr>
                 <td>Pro Incentive</td>
                 <td>{{ proincentive }}</td>
               </tr>
         <tr *ngFor="let item of courseFeeData" >
             <td>{{item.subTransCode}}</td>
             <td>{{item.headAmount}}</td>
         </tr>
         <!-- <tr>
             <td>Accommodation Fee</td>
             <td>{{accomodationFee}}</td>
         </tr>
         <tr>
             <td>Coaching Fee</td>
             <td>{{coachingFee}}</td>
         </tr> -->
         
         <tr>
             <td class="maintext">Akash Books Cost</td>
             <td>{{akashtotal}}</td>
         </tr>
         <tr *ngFor="let item of akashData" >
           <td>{{item.subTransCode}}</td>
           <td>{{item.headAmount}}</td>
       </tr>
     </tbody>
     </table>
    </div>
    <button id="saveButton"  (click)="save()">Save</button>
 </div>

